module.exports = {"211481001":"古城街道","211481002":"宁远街道","211481004":"温泉街道","211481007":"四家屯街道","211481008":"菊花街道","211481101":"曹庄镇","211481103":"沙后所满族镇","211481104":"东辛庄满族镇","211481105":"郭家满族镇","211481106":"红崖子镇","211481107":"徐大堡镇","211481108":"高家岭满族镇","211481201":"羊安满族乡","211481203":"元台子满族乡","211481204":"白塔满族乡","211481206":"望海满族乡","211481207":"刘台子满族乡","211481208":"大寨满族乡","211481209":"南大满族乡","211481210":"围屏满族乡","211481212":"碱厂满族乡","211481213":"三道沟满族乡","211481215":"旧门满族乡","211481216":"药王满族乡","211481400":"兴城飞地经济区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/211481.json
// module id = 690
// module chunks = 0